import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api.ts";
import { day, digits, money, STATUS, wa } from "../format.ts";
import { Act, Empty } from "../ui.tsx";

interface G { id: string; name: string; phone: string | null; email: string; role: string; guestOnly: boolean; banned: boolean; createdAt: string; bookings: number; spentMinor: number }
interface GFile { person: { id: string; name: string; phone: string | null }; stays: { id: string; code: string; status: string; checkIn: string; checkOut: string; totalMinor: number; currency: string; listingTitle: { fr: string } | null }[] }

function Detail({ g, reload }: { g: G; reload: () => void }) {
  const [file, setFile] = useState<GFile | null>(null);
  const [name, setName] = useState(g.name);
  const [phone, setPhone] = useState(g.phone ?? "");
  useEffect(() => { api<GFile>(`/v1/staff/guests/${g.id}`).then(setFile).catch(() => undefined); }, [g.id]);
  const dirty = name.trim() !== g.name || digits(phone) !== (g.phone ?? "");
  return (
    <div className="card stackc">
      <div className="formrow">
        <label className="field"><span>Nom</span><input value={name} onChange={(e) => setName(e.target.value)} /></label>
        <label className="field"><span>Téléphone</span><input inputMode="numeric" value={phone} onChange={(e) => setPhone(e.target.value)} /></label>
      </div>
      <div className="quick">
        <Act disabled={!dirty || name.trim().length < 2 || digits(phone).length < 8} run={async () => { await api(`/v1/staff/guests/${g.id}`, { method: "PATCH", body: { name: name.trim(), phone: digits(phone) } }); reload(); }}>Enregistrer</Act>
        {g.phone && <a className="chip" href={`tel:+${digits(g.phone)}`}>Appeler</a>}
        {g.phone && <a className="chip" href={wa(g.phone, `Bonjour ${g.name}, c'est l'équipe Sekani.`) ?? "#"} target="_blank" rel="noreferrer">WhatsApp</a>}
      </div>
      {file && (file.stays.length === 0 ? <p className="muted small">Aucun séjour.</p> : (
        <ul className="rows" style={{ borderTop: 0 }}>
          {file.stays.map((s) => <li key={s.id} className="kv"><Link to={`/b/${s.id}`} className="link"><span className="code num">{s.code}</span> {s.listingTitle?.fr}</Link><span className="muted small">{day(s.checkIn)} → {day(s.checkOut)} · {STATUS[s.status] ?? s.status} · {money(s.totalMinor, s.currency)}</span></li>)}
        </ul>
      ))}
    </div>
  );
}

export function Guests() {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState<G[] | null>(null);
  const [open, setOpen] = useState<string | null>(null);
  const load = useCallback(() => { api<G[]>(`/v1/staff/guests?q=${encodeURIComponent(q)}`).then(setRows).catch(() => setRows([])); }, [q]);
  useEffect(() => { const t = setTimeout(load, 200); return () => clearTimeout(t); }, [load]);
  return (
    <section>
      <header className="pagehead"><h1>Clients</h1><p className="muted small">Tous les clients, avec ou sans compte. Corrigez un nom ou un numéro mal saisi ici.</p></header>
      <label className="field" style={{ marginBottom: 16 }}><span>Rechercher</span><input type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nom, téléphone ou e-mail" /></label>
      {rows && rows.length === 0 && <Empty>Aucun résultat.</Empty>}
      <ul className="rows">
        {rows?.map((g) => (
          <li key={g.id} className="guestrow">
            <button className="rowbtn" onClick={() => setOpen(open === g.id ? null : g.id)} aria-expanded={open === g.id}>
              <span><b>{g.name}</b> {g.guestOnly ? <span className="pill sm">sans compte</span> : <span className="pill sm">compte</span>} {g.role !== "user" && <span className="pill sm">{g.role}</span>}</span>
              <span className="muted small num">{g.phone ? `+${digits(g.phone)}` : "—"} · {g.bookings} séjour{g.bookings > 1 ? "s" : ""}{g.spentMinor > 0 ? ` · ${money(g.spentMinor, "MAD")}` : ""}</span>
            </button>
            {open === g.id && <Detail g={g} reload={load} />}
          </li>
        ))}
      </ul>
    </section>
  );
}
